import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { TableHeaderPagination } from '~/modules/resourcing/common/components';
import TableSortLabel from '~/modules/common/components/ListTable/components/DataTable/components/TableSortLabel';

const useStyles = makeStyles(theme => ({
  tabelCell: {
    minWidth: theme.spacing(31.5),
    alignSelf: 'stretch',
    marginLeft: theme.spacing(-0.75)
  },
  role: {
    minWidth: theme.spacing(4.3)
  }
}));

const HeaderContentModel0 = ({
  resourceSortField,
  sort,
  onSortChange,
  loadingUsers,
  paginationClasses,
  currentPage,
  setCurrentPage,
  pageSize,
  currentPageRowCount
}) => {
  const classes = useStyles();

  return (
    <>
      <TableSortLabel
        className={classes.tabelCell}
        field={resourceSortField}
        show
        active={sort?.field === resourceSortField}
        direction={sort && sort.direction && sort.direction.toLowerCase()}
        onClick={onSortChange}
      >
        <FormattedMessage id="resourceRequestChartHeader.resources" />
      </TableSortLabel>
      <div className={classes.role}>
        <FormattedMessage id="resourceRequestChartHeader.role" />
      </div>
      {!loadingUsers ? (
        <TableHeaderPagination
          classes={paginationClasses}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          isPastPaginationLimit={false}
          currentPageRowCount={currentPageRowCount}
        />
      ) : null}
    </>
  );
};

HeaderContentModel0.propTypes = {
  resourceSortField: PropTypes.string,
  sort: PropTypes.object,
  onSortChange: PropTypes.func,
  loadingUsers: PropTypes.bool,
  paginationClasses: PropTypes.object,
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  pageSize: PropTypes.number,
  currentPageRowCount: PropTypes.number
};

export default HeaderContentModel0;
